import React from 'react';
import { Button } from '../../../components/ui/Button';
import { Video } from '../../../types/videos';

export type DetailViewProps = {
  data: Video | null;
  loading?: boolean;
  error?: string | null;
  onBack: () => void;
};

export const VideoDetailView: React.FC<DetailViewProps> = ({ data, loading, error, onBack }) => {
  return (
    <div className="w-full">
      <div className="mb-3 flex items-center justify-between">
        <h1 className="text-xl font-semibold">Video Details</h1>
        <div className="flex gap-2">
          <Button variant="outline" onClick={onBack}>Back</Button>
        </div>
      </div>
      {loading && <div>Loading...</div>}
      {error && <div className="text-sm text-destructive">{error}</div>}
      {data && (
        <div className="rounded border p-4">
          <div className="grid grid-cols-1 gap-3 md:grid-cols-2">
            <Field label="ID" value={String(data.id)} />
            <Field label="Filename" value={data.filename} />
            {/*<Field label="Duration" value={data.durationSec ? `${data.durationSec} s` : '-'} />*/}
          </div>
        </div>
      )}
    </div>
  );
};

const Field: React.FC<{ label: string; value: string }> = ({ label, value }) => (
  <div>
    <div className="text-xs text-muted-foreground">{label}</div>
    <div className="mt-1 text-sm break-all">{value}</div>
  </div>
);

export default VideoDetailView;
